import { useRouterState } from '@tanstack/react-router';

import { useDrawerNavigation } from '@/providers/DrawerNavigationProvider';
import { uiStore } from '@/stores/ui.store';

import { navRailPanelFor } from './nav-rail.utils';

export const useNavRailPanel = () => {
  'use no memo';
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return uiStore.chromeless ? 'agents' : navRailPanelFor(pathname);
};

export const usePanelToggle = () => {
  const panel = useNavRailPanel();
  const drawer = useDrawerNavigation();
  const narrow = uiStore.isNarrowViewport;

  return {
    available: panel !== null,
    opens: narrow ? !drawer.isOpen : uiStore.sidebarCollapsed,
    toggle: () => {
      if (!panel) return;
      if (narrow) drawer.setIsOpen(!drawer.isOpen);
      else uiStore.toggleSidebarCollapsed();
    },
  };
};
